import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TestiLikeComment from '../components/ui/TestiLikeComment';
import TestiThumb from '../components/ui/TestiThumb';
import Avatar from '../components/ui/Avatar';

const FLAG = (code) => `https://flagcdn.com/24x18/${code}.png`;

const categories = [
  { id: 'all', label: 'Toutes' },
  { id: 'message', label: '✨ Message personnel' },
  { id: 'musical', label: '🎵 Moment musical' },
  { id: 'lettre', label: '💌 Lettre imaginaire' },
  { id: 'universel', label: '🌍 Message universel' },
  { id: 'question', label: '❓ Question à lui poser' },
  { id: 'cadeau', label: '🎁 Cadeau à lui offrir' },
  { id: 'danse', label: '💃 Danser avec lui' },
];

const btnActive = { border: '2px solid #8b1a2a', borderRadius: '8px', padding: '7px 14px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial,sans-serif', background: '#8b1a2a', color: '#fff' };
const btnInactive = { border: '2px solid #8b1a2a', borderRadius: '8px', padding: '7px 14px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial,sans-serif', background: '#fff', color: '#1a1010' };
const catInactive = { border: '2px solid #c49090', borderRadius: '8px', padding: '7px 14px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial,sans-serif', background: '#fff', color: '#4a3030' };

export default function Etsi() {
  const token = localStorage.getItem('mjtoken');
  const currentUserId = (() => { try { return JSON.parse(atob((token||'').split('.')[1].replace(/-/g,'+').replace(/_/g,'/'))).id; } catch { return undefined; } })();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCat, setActiveCat] = useState('all');
  const [activeMedia, setActiveMedia] = useState('all');
  const [sortBy, setSortBy] = useState('recent');
  const [search, setSearch] = useState('');
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch('/api/testimonials?section=etsi')
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setTestimonials(data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Mapping champs MongoDB → affichage
  const mapped = testimonials.map(t => ({
    ...t,
    name: t.authorName,
    country: t.authorCountry || '',
    flagCode: t.location?.country?.toLowerCase().slice(0, 2) || 'fr',
    city: t.location?.city || '',
    year: t.eventDate || '',
    text: t.content,
    tour: t.eventName || '',
    cat: t.tags?.[0] || 'message',
    media: t.photos?.length > 0 ? 'photo' : ((t.videos?.length > 0 || t.videoUrl) ? 'video' : 'none'),
    videoUrl: t.videoUrl || '',
    initials: (t.authorName || 'A').slice(0, 2).toUpperCase(),
    photo: t.authorPhoto || '',
    avatar: t.authorAvatar || '',
  }));

  const filtered = mapped.filter(t => {
    if (activeCat !== 'all' && t.cat !== activeCat) return false;
    if (activeMedia === 'photo' && t.media !== 'photo') return false;
    if (activeMedia === 'none' && t.media !== 'none') return false;
    if (search && !t.text?.toLowerCase().includes(search.toLowerCase()) && !t.name?.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  }).sort((a, b) => sortBy === 'likes'
    ? (b.likes?.length || 0) - (a.likes?.length || 0)
    : new Date(b.createdAt) - new Date(a.createdAt)
  );

  const open = mapped.find(t => t._id === openId);

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', fontFamily: 'Arial,sans-serif' }}>

      <div style={{ background: 'linear-gradient(135deg,#1a1010,#2a1518)', padding: '36px 40px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '10px', right: '40px', fontSize: '120px', color: 'rgba(255,255,255,0.04)', fontFamily: 'Georgia,serif', lineHeight: 1 }}>"</div>
        <p style={{ fontSize: '12px', letterSpacing: '0.15em', color: '#e8a0a0', marginBottom: '8px', fontWeight: '700' }}>— TÉMOIGNAGES</p>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: '30px', color: '#fff', fontWeight: '400', marginBottom: '10px' }}>
          ✨ Et si… <em style={{ color: '#e8a0a0', fontStyle: 'italic' }}>j'avais pu le rencontrer</em>
        </h1>
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.8', maxWidth: '500px', marginBottom: '16px' }}>
          Ces fans n'ont jamais eu la chance de le croiser. Mais si c'était arrivé — voilà ce qu'ils lui auraient dit, demandé, chanté.
        </p>
        <Link to="/temoigner"><button style={{ ...btnActive, padding: '10px 22px' }}>✦ Écrire mon "Et si…"</button></Link>
      </div>

      <div style={{ background: '#f5eeeb', borderBottom: '2px solid #c49090', padding: '14px 40px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', color: '#1a1010', fontWeight: '700', minWidth: '80px' }}>Médias :</span>
          {[{ id: 'all', label: 'Tous' }, { id: 'photo', label: '📸 Avec photo' }, { id: 'none', label: '✍️ Texte seul' }].map(m => (
            <button key={m.id} onClick={() => setActiveMedia(m.id)} style={activeMedia === m.id ? btnActive : btnInactive}>{m.label}</button>
          ))}
          <div style={{ width: '1px', height: '24px', background: '#c49090', margin: '0 8px' }} />
          <span style={{ fontSize: '13px', color: '#1a1010', fontWeight: '700' }}>Trier par :</span>
          <button onClick={() => setSortBy('recent')} style={sortBy === 'recent' ? btnActive : btnInactive}>Plus récents</button>
          <button onClick={() => setSortBy('likes')} style={sortBy === 'likes' ? btnActive : btnInactive}>Plus aimés</button>
        </div>
      </div>

      <div style={{ background: '#fff', borderBottom: '2px solid #c49090', padding: '14px 40px' }}>
        <div style={{ fontSize: '13px', color: '#1a1010', fontWeight: '700', marginBottom: '10px' }}>Type de témoignage :</div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {categories.map(c => (
            <button key={c.id} onClick={() => setActiveCat(c.id)} style={activeCat === c.id ? btnActive : catInactive}>{c.label}</button>
          ))}
        </div>
      </div>

      <div style={{ background: '#f5eeeb', borderBottom: '2px solid #c49090', padding: '12px 40px' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Rechercher un mot, un nom…"
          style={{ width: '100%', border: '2px solid #8b1a2a', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#1a1010', outline: 'none', background: '#fff', fontFamily: 'Arial,sans-serif' }} />
      </div>

      <div style={{ padding: '24px 40px' }}>
        {open ? (
          <div style={{ background: 'linear-gradient(135deg,#1a1010,#2a1518)', borderRadius: '12px', padding: '28px', marginBottom: '24px', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: '10px', right: '20px', fontSize: '80px', color: 'rgba(255,255,255,0.04)', fontFamily: 'Georgia,serif' }}>"</div>
            <button onClick={() => setOpenId(null)} style={{ fontSize: '13px', color: '#e8a0a0', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '16px', display: 'block', fontWeight: '700' }}>← Retour</button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <Avatar photo={open.photo} avatar={open.avatar} name={open.name} initials={open.initials} size={40} bg="#8b1a2a" color="#fff" />
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px' }}>
                  {open.flagCode && <img src={FLAG(open.flagCode)} alt="" style={{ width: '20px', height: '15px', borderRadius: '2px' }} />}
                  <span style={{ fontSize: '15px', fontWeight: '700', color: '#fff' }}>{open.name}</span>
                </div>
                <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>{open.country}{open.city ? ' · ' + open.city : ''}{open.year ? ' · ' + open.year : ''}</div>
              </div>
            </div>
            {open.tour && (
              <div style={{ display: 'inline-block', fontSize: '12px', background: 'rgba(139,26,42,0.3)', color: '#e8a0a0', padding: '3px 10px', borderRadius: '4px', marginBottom: '12px' }}>{open.tour}</div>
            )}
            <p style={{ fontSize: '16px', color: '#fff', lineHeight: '1.9', fontStyle: 'italic', fontFamily: 'Georgia,serif', position: 'relative' }}>"{open.text}"</p>
            {open.photos?.length > 0 && (
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                {open.photos.map((p, i) => (
                  <img key={i} src={p} alt="" className="lb-img" style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 6, border: '1px solid rgba(255,255,255,0.2)' }} />
                ))}
              </div>
            )}
            {open.videos?.length > 0 && (
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                {open.videos.map((v, i) => (
                  <video key={i} src={v} controls style={{ width: 220, borderRadius: 6, border: '1px solid rgba(255,255,255,0.2)' }} />
                ))}
              </div>
            )}
            {open.videoUrl && (() => {
              const u = open.videoUrl; let embed = '';
              const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
              const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
              if (yt) embed = 'https://www.youtube.com/embed/' + yt[1];
              else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1];
              return embed
                ? <div style={{ marginTop: 12 }}><iframe title="video" src={embed} style={{ width: '100%', maxWidth: 420, aspectRatio: '16 / 9', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 6 }} allow="accelerometer; autoplay; encrypted-media; picture-in-picture; clipboard-write" allowFullScreen /></div>
                : <div style={{ marginTop: 12 }}><a href={u} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#e8a0a0' }}>Voir la video</a></div>;
            })()}
            <TestiLikeComment
              testimonialId={open._id}
              initialLikes={open.likes?.length || 0}
                    likesList={open.likes || []}
              initialComments={open.comments || []}
              currentUserId={currentUserId}
              token={token}
            />
          </div>
        ) : (
          <>
            {loading && (
              <div style={{ textAlign: 'center', padding: '40px', color: '#9a8080', fontSize: '14px' }}>Chargement…</div>
            )}
            {!loading && testimonials.length === 0 && (
              <div style={{ textAlign: 'center', padding: '40px', color: '#8b1a2a', fontSize: '14px' }}>
                Aucun témoignage pour l'instant. Soyez le premier à écrire votre "Et si…" !
              </div>
            )}
            {!loading && testimonials.length > 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '14px' }}>
                {filtered.map(t => (
                  <div key={t._id} onClick={() => setOpenId(t._id)}
                    style={{ background: '#fff', border: '2px solid #c49090', borderRadius: '10px', padding: '18px', cursor: 'pointer', position: 'relative', overflow: 'hidden', transition: 'border-color 0.15s', display: 'flex', gap: '14px', alignItems: 'flex-start' }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = '#8b1a2a'}
                    onMouseLeave={e => e.currentTarget.style.borderColor = '#c49090'}>
                    <div style={{ position: 'absolute', top: '-5px', right: '10px', fontSize: '60px', color: 'rgba(139,26,42,0.05)', fontFamily: 'Georgia,serif' }}>"</div>
                    <TestiThumb t={t} size={88} radius={8} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                      <Avatar photo={t.photo} avatar={t.avatar} name={t.name} initials={t.initials} size={34} bg="#8b1a2a" color="#fff" />
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px' }}>
                          {t.flagCode && <img src={FLAG(t.flagCode)} alt="" style={{ width: '18px', height: '13px', borderRadius: '2px' }} />}
                          <span style={{ fontSize: '13px', fontWeight: '700', color: '#1a1010' }}>{t.name}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#6a5050' }}>{t.country}{t.year ? ' · ' + t.year : ''}</div>
                      </div>
                    </div>
                    {t.tour && (
                      <div style={{ display: 'inline-block', fontSize: '12px', padding: '3px 9px', borderRadius: '6px', background: '#f5eeeb', color: '#8b1a2a', border: '1px solid #c49090', fontWeight: '600', marginBottom: '8px' }}>
                        {t.tour}
                      </div>
                    )}
                    <p style={{ fontSize: '12px', color: '#1a1010', lineHeight: '1.7', fontStyle: 'italic', fontFamily: 'Georgia,serif', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', marginBottom: '10px' }}>
                      "{t.text}"
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ fontSize: 12, color: '#9a8080', display: 'flex', gap: 10 }}>
                        <span>♡ {t.likes?.length || 0}</span>
                        {t.comments?.length > 0 && <span>💬 {t.comments.length}</span>}
                      </div>
                      <span style={{ fontSize: '12px', color: '#8b1a2a', fontWeight: '700' }}>Lire →</span>
                    </div>
                    </div>
                  </div>
                ))}
                {filtered.length === 0 && (
                  <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px', color: '#9a8080', fontSize: '14px' }}>Aucun témoignage pour ces filtres.</div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
